export default __webpack_public_path__ + "static/media/green-tick.ecc55735.svg";